<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'免责条款'"  :activeNames="'免责条款'"></PHeader>
		
		<article>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 免责条款</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:left;width:94%;">免责条款</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:left;width:94%;;margin-top: 20px;line-height: 32px;font-size: 14px;color: #333333;">
				<div style="margin-top: 20px;">一、责任限制</div>
				<div>1.1上海和华利盛律师事务所（以下简称"和华利盛"）是一家总部位于中国上海的大型综合性律师事务所。</div>
				<div>1.2本网站系和华利盛的唯一官方网站，由和华利盛设立并运营。和华利盛在本网站上发布的全部信息仅供网站访问者作为一般参考，不应被视为和华利盛就某一特定事项给出法律意见。和华利盛不承担由于网站访问者访问本网站或者依赖本网站上的信息而产生的任何损失。网站访问者访问本网站或获取本网站上的信息不代表与和华利盛达成律师委托或法律咨询。网站访问者如需获得任何法律意见，应与律师签署书面协议。</div>
				<div>1.3本网站可能链接至其他网站，其他网站也可能链接至本网站。和华利盛不承担网站访问者访问其他网站内容而产生的责任。</div>
				<div>1.4 和华利盛作为一家大型律师事务所，可能存在被冒充、伪装的情况。如果您收到声称是和华利盛律师的电话、短信、电子邮件等方式的联系，建议使用本网站（www.hehualawyer.com）上所发布该律师的联系方式直接与其取得联络，并确认联系的真伪。和华利盛不承担网站访问者与冒充、伪装和华利盛律师之间联络、交易、委托等行为所产生的任何责任。</div>
				<div>二、 知识产权</div>
				<div>2.1 “和华利盛Logo”，“和华利盛”等文字、图形及组合，以及本网站的标识、名称等均为和华利盛在中国或其他国家、地区的注册商标，和华利盛拥有完整的权利。未经和华利盛书面授权，任何人不得以任何方式进行使用，包括但不限于复制、传播、展示或其他处理。</div>
				<div>2.2对于本网站上发布的所有信息，包括但不限于文字、图片等，和华利盛及和华利盛律师保留所有知识产权相关权利，未经授权请勿用于商业目的使用，包括但不限于复制、展示、镜像、上传、下载、打印等。</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
